import { pumaAPI, dataAPI } from "./api"
import { UserFormattingSettingsDTO } from "./models/fields"
import { IUserFormattingSettings } from "../components/applicationheader/components/usermenu"
import { ITenForceWindow } from "../global"

declare let window: ITenForceWindow

export const getHomePage = (): Promise<string> =>
    pumaAPI.getText("resources/homepageurl")

export const getUserFormattingSettings = (): Promise<IUserFormattingSettings> =>
    dataAPI
        .getJSON(
            "Users/Current()?$select=RegionalFormat&%24expand=RegionalFormat,TimeZone",
        )
        .then(
            ({
                RegionalFormat: {
                    DateTimeFormat: { ShortDatePattern, ShortTimePattern },
                    NumberFormat: {
                        DecimalDigits = 3,
                        DecimalSeparator = window?.Sys?.CultureInfo
                            ?.CurrentCulture?.numberFormat
                            ?.NumberDecimalSeparator ?? ".",
                        GroupSeparator = ",",
                        GroupSizes = [3],
                    },
                },
                TimeZone: { Id, Label },
            }: UserFormattingSettingsDTO) => {
                return {
                    numberFormat: {
                        decimalSeparator: DecimalSeparator,
                        groupSeparator: GroupSeparator,
                        groupSizes: GroupSizes,
                        decimalDigits: DecimalDigits,
                    },
                    shortDatePattern: ShortDatePattern,
                    shortTimeFormat: ShortTimePattern,
                    timeZone: {
                        id: Id,
                        label: Label,
                    },
                    isInitialized: true,
                }
            },
        )
